'use strict';
/**
 * <hof-panel> - Hall of Fame sub-screen. See settings-panel.js for the
 * light-DOM / classic-script / load-order rationale shared by all four
 * panel components.
 */
class HofPanel extends HTMLElement {
  connectedCallback() {
    if (this.childElementCount) return;
    this.innerHTML = `
      <div class="settings-header">
        <button id="hof-back-btn" class="icon-btn-inline" aria-label="Close" title="Close">
          <svg class="icon"><use href="#icon-back"/></svg>
        </button>
        <h2>Hall of Fame</h2>
      </div>
      <ol id="hof-list" class="hof-list"></ol>
    `;
  }
}

customElements.define('hof-panel', HofPanel);
